import {addQueryToPath} from '../../../libs/shared/helpers/src/browser/urlHelpers';
import {InboxesFiltersEnum} from '../../models/url/inboxesUrlModel';
import {
  hasSearchInInboxesParameters,
  InboxesParameters,
  InboxesParametersTypesEnum,
} from '../../store/panels/inboxes/parameters/inboxesParameters';
import {buildParametersSearchFetchTotalPath} from '../../store/panels/inboxes/parameters/inboxesParametersFetchHelpers';

/*
 * Count URL.
 */

export function buildConversationCountUrl(companyUrl: string, inboxesParameters: InboxesParameters) {
  if (hasSearchInInboxesParameters(inboxesParameters)) {
    // If we're in a search, get the search count.
    return `${companyUrl}${buildParametersSearchFetchTotalPath(inboxesParameters, inboxesParameters.search)}`;
  }

  switch (inboxesParameters.type) {
    case InboxesParametersTypesEnum.INBOX:
    case InboxesParametersTypesEnum.TEAMMATE_INBOX:
      return buildInboxConversationCountUrl(companyUrl, inboxesParameters.inboxId, inboxesParameters.filters);

    case InboxesParametersTypesEnum.VIEW:
    case InboxesParametersTypesEnum.TEAMMATE_VIEW:
      return buildTagConversationCountUrl(companyUrl, inboxesParameters.viewId, inboxesParameters.filters);

    case InboxesParametersTypesEnum.USER:
    case InboxesParametersTypesEnum.TEAMMATE:
      return buildTeammateConversationCountUrl(
        companyUrl,
        inboxesParameters.teammateId,
        inboxesParameters.folder,
        inboxesParameters.filters,
      );

    case InboxesParametersTypesEnum.TEAM:
      return buildTeamConversationCountUrl(companyUrl, inboxesParameters.teamId, inboxesParameters.filters);

    case InboxesParametersTypesEnum.GLOBAL:
      return undefined;

    default:
      return undefined;
  }
}

/*
 * Helpers.
 */

function buildTeammateConversationCountUrl(
  companyUrl: string,
  teammateId: number,
  folder: string,
  filters: ReadonlyArray<InboxesFiltersEnum>,
) {
  return addQueryToPath(`${companyUrl}/team/${teammateId}/conversations_count/${folder}`, {
    filters: filters.join(','),
  });
}

function buildTeamConversationCountUrl(
  companyUrl: string,
  teamId: number,
  filters: ReadonlyArray<InboxesFiltersEnum>,
) {
  return addQueryToPath(`${companyUrl}/teams/${teamId}/conversations_count`, {
    filters: filters.join(','),
  });
}

function buildInboxConversationCountUrl(
  companyUrl: string,
  inboxId: number,
  filters: ReadonlyArray<InboxesFiltersEnum>,
) {
  return addQueryToPath(`${companyUrl}/inboxes/${inboxId}/conversations_count`, {
    filters: filters.join(','),
  });
}

function buildTagConversationCountUrl(
  companyUrl: string,
  tagId: number,
  filters: ReadonlyArray<InboxesFiltersEnum>,
) {
  return addQueryToPath(`${companyUrl}/tags/${tagId}/conversations_count`, {
    filters: filters.join(','),
  });
}
